export default class Search {
  static get PARAM_SEARCH() {
    return 'search'
  }

  static get PARAM_FIELDS() {
    return 'searchfields'
  }

  constructor(criteria) {
    this._search = ''
    this._fields = null
    this._criteria = criteria

    if (this._criteria) {
      this.parseCriteria()
    }
  }

  parseCriteria() {
    const paramsSearch = this._criteria.match(
      // eslint-disable-next-line no-useless-escape
      new RegExp(`${Search.PARAM_SEARCH}=(.+?)\/`, 'i'),
    )

    if (paramsSearch && paramsSearch[1]) {
      this._search = decodeURIComponent(paramsSearch[1])
      const paramsFields = this._criteria.match(
        // eslint-disable-next-line no-useless-escape
        new RegExp(`${Search.PARAM_FIELDS}=(.+?)\/`, 'i'),
      )

      if (paramsFields && paramsFields[1]) {
        this._fields = paramsSearch[1].split(',')
      }
    }
  }

  getSearch() {
    return {
      search: this._search,
      fields: this._fields,
    }
  }

  get value() {
    return this._search
  }

  get fields() {
    return this._fields
  }

  setSearch(search, fields) {
    if (typeof search !== 'string') {
      throw new Error('Param [search] must be a string')
    }

    if (fields && !Array.isArray(fields)) {
      throw new Error('Param [fields] must be a array')
    }

    this._search = search
    this._fields = fields
  }

  clearSearch() {
    this._search = ''
    this._fields = null
  }

  getCriteria() {
    if (!this._search) {
      return ''
    }

    const searchPath = `${Search.PARAM_SEARCH}=${encodeURIComponent(
      this._search,
    )}/`
    const searchFieldsPath = this._fields
      ? `${Search.PARAM_FIELDS}=${this._fields.join(',')}/`
      : ''

    return searchPath + searchFieldsPath
  }

  getApiCriteria() {
    if (!this._search) {
      return ''
    }

    const searchPath = `${Search.PARAM_SEARCH}=${encodeURIComponent(
      this._search,
    )}`
    const searchFieldsPath = this._fields
      ? `&${Search.PARAM_FIELDS}=${this._fields.join(',')}`
      : ''

    return searchPath + searchFieldsPath
  }
}
